<span class="cell cell--drag fa fa-arrows" [ngClass]="{ disabled: !policyPermissions.editField }"></span>
<span class="cell cell--name bold text-ellipsis">{{ field.name }} / {{ field.label }}</span>
<span class="cell cell--available-in-profile">
    <span class="status-icon" [ngClass]="{ 'status-icon__yes': field.use_in_profile }"></span>
</span>
<span class="cell cell--mapped">
    <span class="status-icon" [ngClass]="{ 'status-icon__yes': field.is_mapped }"></span>
</span>
<span class="cell cell--type">{{ fieldTypeName }}</span>
<span class="cell cell--default-value text-ellipsis">Default: {{ fieldDefaultValue }}</span>
<span class="cell cell--status">{{ fieldStatusName }}</span>
<div class="options">
    <button *ngIf="policyPermissions.editField" class="cm-link" type="button" (click)="onEditClick()">Edit</button>
    <button
        *ngIf="!field.is_mapped && policyPermissions.deleteField"
        class="cm-link"
        type="button"
        (click)="onDeleteClick()"
    >
        Delete
    </button>
</div>
